export default __webpack_public_path__ + "images/74a94c590b3f58af335ae6bc07fe2565-KissCalLogoWithText-light.png";